import axios from './configAxios';

export const putEntryReportsApi = async ({ reportId, requestData }) => {
	return await axios.put(`/${reportId}/update/`, requestData);
};
